import { z } from 'zod'

export const MEMBERSHIP_PARTNER_GRAPH_READINESS_CONTRACT_VERSION = '1.0.0' as const

export const membershipPartnerGraphReadinessResponseSchema = z.record(z.unknown())

export type MembershipPartnerGraphReadinessResponse = z.infer<typeof membershipPartnerGraphReadinessResponseSchema>
